import * as React from 'react';

const popOverBorderStyles = {
  padding: 0,
  margin: 0,
  boxShadow: '2px 2px 10px rgba(0,0,0,0.25)',
  border: '1px solid rgba(0,0,0,.15) !default',
  borderRadius: '3px',
  background: '#fff',
  backgroundClip: 'padding-box',
};

const popOverContainerStyles = {
  display: 'flex',
  flexDirection: 'column' as const,
  padding: 0,
  margin: 0,
  minWidth: '150px',
  lineHeight: '22px',
  color: '#2a2f34',
  fontSize: '14px',
  fontFamily: 'Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
};

export interface PopoverBorderProps {
  className?: string;
  onClick?: () => void;
  onMousedown?: () => void;
}

export class PopoverBorder extends React.Component<PopoverBorderProps, {}> {
  render() {
    const className = this.props.className
      ? `bnt-hc-popover-border ${this.props.className}`
      : 'bnt-hc-popover-border';
    return (
      <div
        className={className}
        onClick={this.handleClick}
        onMouseDown={this.handleMousedown}
        style={{ ...popOverContainerStyles, ...popOverBorderStyles }}
      >
        {this.props.children}
      </div>
    );
  }

  private handleClick = (event: React.MouseEvent<any>) => {
    if (this.props.onClick) {
      event.stopPropagation();
      this.props.onClick();
    }
  };

  private handleMousedown = (event: React.MouseEvent<any>) => {
    if (this.props.onMousedown) {
      event.stopPropagation();
      this.props.onMousedown();
    }
  };
}
